<template>
  <div>
    <!-- Loading -->
    <div v-if="loading" class="loading-container">
      <div class="spinner"></div>
      <div class="loading-text">Đang tải người chơi...</div>
    </div>

  <div v-else>
    <div class="player-grid-title">Xin mời chọn nhà tài trợ 😆</div>
    <div class="player-grid">
      <div
        v-for="player in players"
        :key="player.playerId"
        class="player-item"
        :class="{ selected: isSelected(player) }"
        @click="togglePlayer(player)"
      >
        <img
          v-if="player.playerAvatar"
          :src="player.playerAvatar"
          class="avatar"
          :alt="player.playerName"
        />
        <span>{{ player.playerName }}</span>
      </div>
    </div>
  </div>

  </div>
</template>

<script>
export default {
  props: {
    modelValue: Array
  },
  emits: ['update:modelValue'],
  data() {
    return {
      players: [],
      loading: true
    };
  },
  mounted() {
    fetch("https://script.google.com/macros/s/AKfycbx4On0Fs2eKWdPyCS_SnIGvzuwdU6oTMYEYDxhUR5UTub5-NzzJoiDXv92H1nCU5sKPrw/exec?action=getPlayerList")
      .then(res => res.json())
      .then(data => {
        this.players = data.map(player => ({
          playerId: player["playerId"],
          playerName: player["playerName"],
          playerAvatar: player["playerAvatar"]
        }));
      })
      .catch(err =>
        console.error("Lỗi khi tải danh sách người chơi:", err)
      )
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    isSelected(player) {
      return this.modelValue.some(p => p.playerId === player.playerId);
    },
    togglePlayer(player) {
      const selected = [...this.modelValue];
      const index = selected.findIndex(p => p.playerId === player.playerId);

      if (index !== -1) {
        selected.splice(index, 1); // Bỏ chọn
      } else {
        if (selected.length < 2) {
          selected.push(player); // Chọn mới
        }
      }

      this.$emit('update:modelValue', selected);
    }
  }
};
</script>

<style scoped>
.player-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
  row-gap: 16px;
  width: 100%;
  max-width: 480px;
}

.player-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px;
  border: 1px solid #3a3a3a;
  border-radius: 20px;
  font-weight: 500;
  background-color: white;
  cursor: pointer;
  transition: 0.2s ease;
  text-align: center;
  word-break: break-word;
  font-size: 13px;
}

.player-item.selected {
  background-color: rgb(239, 255, 235);
  box-shadow: 2px 2px 4px rgba(110, 165, 17, 0.5);
  border: 2px solid #80c904;
  font-weight: 600;
  color: #354d0c;
}

.avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
}

/* Loading styles */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  gap: 10px;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4caf50;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  animation: spin 1s linear infinite;
}

.loading-text {
  color: #666;
  font-size: 14px;
  font-weight: 500;
}

.player-grid-title {
  text-align: center;
  font-weight: 600;
  font-size: 15px;
  margin: 16px 0 8px;
  color: #333;
  margin-bottom: 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
